import EtoHeader from 'components/Generics/Header/EtoHeader';
import Footer from 'components/Generics/Footer/Footer';
import React from 'react';
import * as S from 'components/AuthError/AuthError.style';
import AuthErrorMsg from 'components/AuthError/AuthErrorMsg';
import { IAuthErrorMessage } from './AuthErrorMsg';

const EtoAuthError = (props: IAuthErrorMessage): React.ReactElement => {

    return (
        <S.Background>
            <S.EtoBackground>
                <EtoHeader />
                <AuthErrorMsg {...props} />
                <Footer />
            </S.EtoBackground>
        </S.Background>
    );
};

export default EtoAuthError;
